//@flow

import { useState } from "react";
import styled, { css } from "styled-components";
import { getCssValue } from "app/lib/cssValues";

import Dropdown from "app/components/shared/Dropdown";
import Button from "app/components/shared/Button";
import Icon from "app/components/shared/Icon";
import Badge from "app/components/shared/Badge";

import type { BuildViewTypes } from ".";
// eslint-disable-next-line no-duplicate-imports
import { BUILD_VIEW_TYPES } from ".";

// TODO this is a one-off implementation following the Dropdown designs in our IX Guide in Figma. We
// should extract this to a reusable pattern in future.
const DropdownOption = styled.a`
  all: unset;
  color: var(--charcoal-700);
  border-radius: 4px;
  padding: 8px;
  text-decoration: none;
  cursor: pointer;

  ${(props) =>
    props.active &&
    css`
      text-decoration: none;
      color: var(--purple-600);
      background-color: var(--purple-100);
    `}

  &:hover {
    text-decoration: none;
    color: var(--purple-600);
  }

  &:focus,
  &:focus-visible {
    outline: none;
    text-decoration: none;
    color: ${(props) =>
      !props.active
        ? getCssValue("--charcoal-700")
        : getCssValue("--purple-600")};
  }

  transition: box-shadow 0.2s;
  &:focus-visible {
    position: relative;
    z-index: 10; /* ensures that the box shadow stacks on top of neighbouring elements in a list view */
    box-shadow:
      0 0 0 2px #fff,
      0 0 0 4px var(--lime-500);
  }
`;

function BuildContentNavigation({
  buildPath,
  currentView,
  waterfallAvailable = false,
}: {
  buildPath: string,
  currentView: BuildViewTypes,
  waterfallAvailable?: boolean,
}) {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const { location } = window;

  // Assemble the URLs for the different views for this build
  const buildUrl = `${location.protocol}//${location.hostname}${buildPath}`;
  const listViewHref = buildUrl;
  const waterfallHref = `${buildUrl}/waterfall`;

  const renderUpgradeBadge = () => {
    return waterfallAvailable ? null : (
      <Badge outline={false} className="white bg-purple right">
        Upgrade
      </Badge>
    );
  };

  return (
    <Dropdown
      offsetY={8}
      className="block"
      onToggle={(isOpen) => {
        setIsDropdownOpen(isOpen);
      }}
      width={180}
    >
      <Button theme="small" title="Show view options">
        <div className="flex gap1 items-center">
          <Icon
            icon="custom/outline/16x/squares-2x2"
            style={{ width: 16, height: 16 }}
          />
          <span>View</span>
          <Icon
            icon={isDropdownOpen ? "up-triangle" : "down-triangle"}
            style={{ width: 7, height: 7 }}
          />
        </div>
      </Button>

      <nav
        className="flex flex-column gap0.5 mx2 py2"
        data-testid="buildViewDropdown"
      >
        <DropdownOption
          active={currentView === BUILD_VIEW_TYPES.JOB_LIST}
          href={listViewHref}
        >
          List
        </DropdownOption>

        <DropdownOption
          active={currentView === BUILD_VIEW_TYPES.WATERFALL}
          href={waterfallHref}
        >
          <span>Waterfall</span>
          {renderUpgradeBadge()}
        </DropdownOption>
      </nav>
    </Dropdown>
  );
}

export default BuildContentNavigation;
